// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3H5VY","box":"WorkspacesBox_box__3xU1z","node":"WorkspacesBox_node__1iYEe"};